<mat-expansion-panel [expanded]="autoExpand">
  <mat-expansion-panel-header>
    <mat-panel-title class="bold">
      {{ 'common.labels.filters' | transloco }}
    </mat-panel-title>
  </mat-expansion-panel-header>
  <form [formGroup]="_filterForm" class="padding">
    <div class="flex-container">
      <mat-form-field class="form-field flex-item">
        <mat-label>{{ 'common.labels.dateAddedFrom' | transloco }}</mat-label>
        <input matInput [matDatepicker]="addedDateFrom" [formControlName]="'addedDateFrom'"
          [placeholder]="'common.labels.dateAddedFrom' | transloco">
        <mat-datepicker-toggle matSuffix [for]="addedDateFrom"></mat-datepicker-toggle>
        <mat-datepicker #addedDateFrom></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="form-field flex-item">
        <mat-label>{{ 'common.labels.dateAddedTo' | transloco }}</mat-label>
        <input matInput [matDatepicker]="addedDateTo" [formControlName]="'addedDateTo'"
          [placeholder]="'common.labels.dateAddedTo' | transloco">
        <mat-datepicker-toggle matSuffix [for]="addedDateTo"></mat-datepicker-toggle>
        <mat-datepicker #addedDateTo></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="flex-container">
      <mat-form-field class="form-field flex-item">
        <mat-label>{{ 'common.labels.amountFrom' | transloco }}</mat-label>
        <input matInput [formControlName]="'amountFrom'" [placeholder]="'common.labels.amountFrom' | transloco" />
      </mat-form-field>
      <mat-form-field class="form-field flex-item">
        <mat-label>{{ 'common.labels.amountTo' | transloco }}</mat-label>
        <input matInput [formControlName]="'amountTo'" [placeholder]="'common.labels.amountTo' | transloco" />
      </mat-form-field>
    </div>
    <div>
      <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.clearFiltersButton' | transloco" type="button"
        (click)="onClear()" [disabled]="!_filterForm.dirty">
        {{ 'common.labels.clearFilters' | transloco }}
      </button>
      <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.filterButton' | transloco" type="submit"
        (click)="onFilter()">
        {{ 'common.labels.filter' | transloco }}
      </button>
    </div>
  </form>
</mat-expansion-panel>